module.exports = __webpack_public_path__ + "img/webpack.5b1ed2f5.png";